import { withTheme } from 'emotion-theming';
import * as React from 'react';
import styled from 'react-emotion';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { constructGallery } from '@jetshop/ui/Gallery/constructGallery';
import Image from '@jetshop/ui/Image/Image';
import Badges from '@jetshop/ui/ProductList/Badges';
const Wrapper = styled('div')`
  position: relative;
  img {
    max-height: 100vh;
  }
  .image-gallery-image {
    position: relative;
    text-align: center;
    ${({ theme }) => theme.above.md} {
      height: 510px;
    }
    & > div {
      ${({ theme }) => theme.above.md} {
        height: 100%;
      }
    }
  }
  .image-gallery-thumbnail-inner {
    font-size: 10px;
    margin-bottom: ${({ theme }) => parseInt(theme.sizes.gap) * 2}px;
  }
  .image-gallery-fullscreen-button {
    margin-bottom: 0.5rem;
  }
  .image-gallery-right-nav,
  .image-gallery-left-nav,
  .image-gallery-fullscreen-button {
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    transition: background 0.3s ease-in-out;
    margin: 0 0.5rem;
    &:hover {
      background: rgba(255, 255, 255, 0.8);
    }
    &:before {
      color: black;
      text-shadow: none;
    }
  }
  .image-gallery-fullscreen-button:before {
    text-shadow: none;
    font-size: 0.7em;
    padding: 0;
  }
  .image-gallery-thumbnail.active {
    border-width: 1px;
  }
  .fullscreen {
    .image-gallery-fullscreen-button {
      margin: 2rem;
    }
    .image-gallery-right-nav,
    .image-gallery-left-nav {
      margin: 0 2rem;
    }
    img {
      width: auto;
      max-width: 100%;
    }
    .image-gallery-thumbnails-wrapper {
      display: none;
    }
  }
  &.unmounted {
    .image-gallery-thumbnails-wrapper,
    button {
      display: none;
    }
    img {
      max-width: 100%;
    }
    .image-gallery-slide {
      display: none;
    }
    .image-gallery-slide:first-of-type {
      display: block;
    }
  }
`;
const Overlay = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

const ZoomContainer = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 110%;
  background: #fff;
  border: 1px solid;
  z-index: 10;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  z-index: 10;
  display: none;
`;

const BadgeWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;

class Gallery extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      isFullscreen: false,
      _mounted: false,
      zoom: {},
      opacity: {},
      currentSlide: 0
    };
  }

  zoomOnMouseOver = (e, item) => {
    //const { images } = this.props;
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const factor = 1.5;
    const pos = 100;
    const x = (((e.pageX - left) / width) * factor - 0.2) * pos;
    const y = (((e.pageY - top) / height) * factor - 0.5) * pos;
    //const imgUrl = images[this.state.selectedImage].sizes[4].url;
    const imgUrl = item;
    const zoom = {
      backgroundPosition: `${x}% ${y}%`,
      backgroundImage: `url("${imgUrl}")`,
      backgroundSize: `200%`,
      backgroundRepeat: `no-repeat`,
      display: 'block'
    };
    this.setState({ zoom: zoom, opacity: { visibility: `hidden` } });
    //this.setState({ zoom: { display: 'none' } } );
    // this.setState({
    //   zoom: `
    //   background-position: ${x}% ${y}%;
    //   background-image: url(${imgUrl});
    //   background-size: 200%;
    //   background-repeat: no-repeat;
    //   `
    // });
  };

  componentDidMount() {
    this.setState({ _mounted: true });
  }
  componentWillUnmount() {
    this.setState({ _mounted: false });
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   return !this.state.transitioning;
  // }
  render() {
    const galleryImages = constructGallery(
      this.props.images,
      this.props.theme,
      this.props.sizes,
      this.props.aspect
    );
    return React.createElement(
      Wrapper,
      { className: this.state._mounted ? 'mounted' : 'unmounted' },
      React.createElement(
        ZoomContainer,
        {
          style: this.state.zoom
        },
        ''
      ),
      React.createElement(ImageGallery, {
        thumbnailPosition: this.props.thumbnailPosition,
        items: galleryImages,
        autoPlay: false,
        showPlayButton: false,
        useBrowserFullscreen: false,
        preventDefaultTouchmoveEvent: this.state.isFullscreen,
        slideOnThumbnailOver: false,
        startIndex: this.state.currentSlide,
        slideDuration: 500,
        onThumbnailClick: (event, slideIndex) => {
          this.setState({ currentSlide: slideIndex });
        },
        onSlide: slideIndex => {
          this.setState({ currentSlide: slideIndex });
        },
        onScreenChange: el => this.setState({ isFullscreen: !!el }),
        renderItem: item => {
          //return (React.createElement("div", { className: "image-gallery-image" }, this.state.isFullscreen ? (React.createElement(Image, { src: item.original, alt: item.originalAlt, title: item.originalTitle, sizes: item.sizes })) : (React.createElement(Image, { src: item.original, alt: item.originalAlt, sizes: item.sizes, title: item.originalTitle }))));

          // : React.createElement(Image, {
          //     src: item.original,
          //     alt: item.originalAlt,
          //     sizes: '510rem',
          //     title: item.originalTitle,
          //     onMouseMove: e => this.zoomOnMouseOver(e, item.original),
          //     onMouseLeave: () => this.setState({ zoom: {}, opacity: {} }),
          //     style: this.state.zoom
          //   })

          return React.createElement(
            'div',
            { className: 'image-gallery-image' },
            this.state.isFullscreen
              ? React.createElement(Image, {
                  src: item.original,
                  alt: item.originalAlt,
                  title: item.originalTitle,
                  aspect: '10:13',
                  sizes: item.sizes
                })
              : React.createElement(Image, {
                  src: item.original,
                  alt: item.originalAlt,
                  sizes: this.sizes,
                  title: item.originalTitle,
                  aspect: '10:13',
                  onMouseMove: e => this.zoomOnMouseOver(e, item.original),
                  onMouseLeave: () => this.setState({ zoom: {}, opacity: {} })
                }),
            React.createElement(
              BadgeWrapper,
              { className: 'image-badge-wrapper' },
              React.createElement(Badges, { badges: this.props.badges })
            )
          );
        },
        renderThumbInner: item => {
          return React.createElement(
            'div',
            { className: 'image-gallery-thumbnail-inner' },
            React.createElement(Image, {
              src: item.thumbnail,
              alt: item.thumbnailAlt,
              title: item.thumbnailTitle,
              sizes: item.sizes
            }),
            item.thumbnailLabel &&
              React.createElement(
                'div',
                { className: 'image-gallery-thumbnail-label' },
                item.thumbnailLabel
              )
          );
        }
      }),
      this.props.children &&
        React.createElement(Overlay, null, this.props.children)
    );
  }
}
Gallery.defaultProps = {
  sizes: [1, 1, 1 / 2, 1 / 2],
  aspect: '10:13',
  thumbnailPosition: 'bottom'
};
export default withTheme(Gallery);
//# sourceMappingURL=Gallery.js.map
